module.exports = __webpack_public_path__ + "media/images/row2_img-c2e5a90206fccd0dc0d742ff22f6a547.jpg";